import React, {useMemo} from 'react';
import {RouteComponentProps} from 'react-router';
import thunk from 'redux-thunk';
import {applyMiddleware, compose, createStore} from 'redux';
import {withRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

import CombinedReducers from './combined-reducers';
import {AppContext} from '../../types';

// Omitting history as its passed through withRouter below
type Options = Omit<AppContext, 'history'>

const createAppStore = (context: AppContext) => {
    const createStoreWithMiddleware = applyMiddleware(
        thunk.withExtraArgument<AppContext>(context)
    )(createStore);

    return createStoreWithMiddleware(
        CombinedReducers,
        // eslint-disable-next-line no-underscore-dangle
        (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()) || compose
    );
};

type ReduxProviderProps = RouteComponentProps & React.PropsWithChildren<Options>

export const ReduxProvider = withRouter(({ children, history, api, getConfigurationItem }: ReduxProviderProps) => {
    // Memo required as this is composed inside react-router Provider for
    // withRouter to provide history for thunk context,
    // Otherwise every route change will render this and create a new store instance.
    const store = useMemo(() => {
        const singleStore = createAppStore({
            history,
            api,
            getConfigurationItem
        });
        // @ts-ignore add store it to window for debugging eg ___store.getState()
        window.___store = singleStore;
        return singleStore;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Provider store={store}>
            {children}
        </Provider>
    );
});
